<template lang="pug">
    r-table( 
        no-data-text='Sin notas de debito'
        no-remove 
        no-search 
        ref='table'
        remind-key='sale-debit-note-list'
        v-bind='tableProps' 
        @detail='submitDetail' 
    )
        template( slot='actions' slot-scope='props' )
            r-btn-action(
                color='dark'
                tooltip='PDF'
                @click="downloadPdf(props)"
            )
                v-icon picture_as_pdf
</template>

<script>
//
import { mapActions } from 'vuex'
import { RTable, RBtnAction } from '@/components/reusable_components/next'
import SaleDebitNoteModel from '@/models/Sale/SlSaleDebitNote'
//
import SaleDebitNoteHeaders from '@/views/Sale/SlSaleDebitNote/SlSaleDebitNoteHeaders'
import SaleDebitNoteFilters from '@/views/Sale/SlSaleDebitNote/SlSaleDebitNoteFilters'
//
import TranslatorService from '../../../services/translator'
//
export default {
    components: {
        RTable,
        RBtnAction,
    },
    computed: {
        /**
         *
         */
        tableProps() {
            return {
                filters: SaleDebitNoteFilters,
                headers: SaleDebitNoteHeaders,
                service: SaleDebitNoteModel,
            }
        },
    },
    methods: {
        /**
         *
         */
        ...mapActions('MenuesModule', ['setItemsTopBar', 'setTitleTopBar']),

        /**
         *
         */
        ...mapActions('SnackbarModalModule', [
            'setErrorSnackbar',
            'setSuccessSnackbar',
        ]),

        /**
         *
         */
        submitCreate() {
            this.$router.push({ name: 'sale-debit-note-create' })
        },

        /**
         *
         */
        submitDetail(event) {
            this.$router.push({
                name: 'sale-debit-note-update',
                params: { id: event.item.id },
            })
        },

        /**
         *
         */
        downloadPdf({ item }) {
            item.downloadPdf()
                .then(this.successDownloadPdf)
                .catch(this.error)
        },

        /**
         *
         */
        error(error) {
            this.setErrorSnackbar(
                TranslatorService(SaleDebitNoteModel, error.response.data)
            )
        },

        /**
         *
         */
        successDownloadPdf() {
            this.setSuccessSnackbar('Nota de debito descargada exitosamente.')
        },
    },
    beforeMount() {
        this.setTitleTopBar('Notas de débito')
    },
    mounted() {
        this.setItemsTopBar([
            {
                action: this.submitCreate,
                icon: 'add_circle',
                text: 'crear nota de debito',
                tooltip: 'Crear nueva nota de debto',
            },
        ])
    },
}
</script>
